import { Box, Text } from "@twilio-paste/core";
import React from "react";

function IconTile({
    Icon,
    iconDisplayName
}: {
    Icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
    iconDisplayName: string;
}) {
    return (
        <Box
            data-testid={iconDisplayName}
            as="li"
            borderRadius="borderRadius30"
            borderWidth="borderWidth10"
            borderColor="colorBorder"
            borderStyle="solid"
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            maxWidth="100%"
            padding={["space40", "space40", "space80"]}
            overflow="hidden"
        >
            <Box>{Icon}</Box>

            <Text as="p" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
                {iconDisplayName}
            </Text>
        </Box>
    );
}

export default IconTile;
